import { Link, useParams } from 'react-router-dom';
import { unitPrice, useCart } from '../store/cart';
import { byId } from '../data/catalog';
import { Card, Money } from '../components/ui';
import { useTitle } from '../components/Layout';

export function Confirmation() {
  const { orderId = '' } = useParams();
  const { orders } = useCart();
  const order = orders.find((o) => o.id === orderId);

  useTitle('Dziękujemy za zamówienie');

  if (!order) {
    return (
      <div className="py-20 text-center text-slate-400">
        <p>Nie znaleźliśmy zamówienia {orderId}.</p>
        <Link className="mt-3 inline-block text-[#9ec5ff] underline" to="/katalog">
          Wróć do katalogu
        </Link>
      </div>
    );
  }

  const subtotal = order.lines.reduce((s, l) => s + unitPrice(l) * l.qty, 0);

  return (
    <div className="mx-auto max-w-2xl">
      <div className="mb-6 text-center">
        <div className="text-5xl">🎉</div>
        <h1 className="mt-2 text-xl font-semibold text-white">Dziękujemy za zamówienie</h1>
        <p className="mt-1 text-[13px] text-slate-400">
          Numer zamówienia: <span className="font-mono text-slate-200">{order.id}</span>
        </p>
        <p className="mt-1 text-[13px] text-slate-400">
          Potwierdzenie wysłaliśmy na adres <span className="text-slate-200">{order.email}</span>
        </p>
      </div>

      <Card className="p-5">
        <h2 className="mb-3 text-sm font-semibold text-white">Zamówione produkty</h2>
        <ul className="space-y-2">
          {order.lines.map((l) => {
            const p = byId(l.productId);
            const v = p?.variants.find((x) => x.sku === l.sku);
            return (
              <li key={l.sku} className="flex items-center gap-3">
                <span
                  className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl"
                  style={{ background: `${p?.color}18` }}
                >
                  {p?.emoji}
                </span>
                <span className="flex-1 text-[13px]">
                  <span className="block text-slate-200">{p?.name}</span>
                  <span className="block text-[11.5px] text-slate-500">
                    {v?.label} · {l.qty} szt. · {l.sku}
                  </span>
                </span>
                <span className="text-[13px] text-slate-200">
                  <Money v={unitPrice(l) * l.qty} />
                </span>
              </li>
            );
          })}
        </ul>

        <div className="my-4 border-t border-[#26304d]" />

        <dl className="space-y-1.5 text-[13px]">
          <div className="flex justify-between">
            <dt className="text-slate-400">Wartość produktów</dt>
            <dd className="text-slate-200">
              <Money v={subtotal} />
            </dd>
          </div>
          {order.discount > 0 && (
            <div className="flex justify-between">
              <dt className="text-slate-400">Rabat {order.coupon}</dt>
              <dd className="text-[#7ef0d0]">
                −<Money v={order.discount} />
              </dd>
            </div>
          )}
          <div className="flex justify-between">
            <dt className="text-slate-400">Dostawa ({order.shippingMethod})</dt>
            <dd className="text-slate-200">
              {order.shippingCost === 0 ? 'gratis' : <Money v={order.shippingCost} />}
            </dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-slate-500">w tym VAT 23%</dt>
            <dd className="text-slate-500">
              <Money v={order.tax} />
            </dd>
          </div>
          <div className="flex justify-between border-t border-[#26304d] pt-2 text-base font-semibold text-white">
            <dt>Zapłacono ({order.paymentMethod})</dt>
            <dd>
              <Money v={order.total} />
            </dd>
          </div>
        </dl>
      </Card>

      <div className="mt-4 flex flex-wrap justify-center gap-2">
        <Link
          to="/konto"
          className="rounded-lg border border-[#26304d] px-4 py-2 text-sm text-slate-200 hover:border-[#4f8cff]"
        >
          Moje zamówienia
        </Link>
        <Link to="/katalog" className="rounded-lg bg-[#4f8cff] px-4 py-2 text-sm font-medium text-white hover:bg-[#3f7ae8]">
          Kupuj dalej
        </Link>
      </div>
    </div>
  );
}
